import React from 'react';
import Layout from 'components/layout';
import Media from 'shared-components/theme/medias';
import styled from 'styled-components';
import colors from 'shared-components/theme/colors';
import { Container } from '@bootstrap-styled/v4';
import ScrollAnimation from 'react-animate-on-scroll';
import {
    gilroyLight,
    gilroyExtrabold,
    gilroyBold,
} from 'shared-components/theme/fonts';

const WorkforceMessagingPrivacy = () => {
    return (
        <Layout page="privacy-policy">
            <Wrapper>
                <Container>
                    <ScrollAnimation animateIn="fadeInUp" animateOnce={false}>
                        <MainHeading>
                            Ibex Work at Home Equipment Return Messaging Privacy Notice
                        </MainHeading>

                        <h2>Scope</h2>
                        <p>
                            This Privacy Notice applies to text messages sent directly by Ibex to current and former employees and other workforce members regarding the return of company-issued Work at Home (WAH) equipment. These messages support employment-related operational processes and compliance with equipment return obligations.
                        </p>

                        <h2>Information Used</h2>
                        <p>
                            Ibex may use mobile telephone numbers and related messaging information collected during the onboarding, employment, or offboarding process to communicate with current and former workforce members regarding the return of company-issued Work at Home equipment and related operational matters.
                        </p>

                        <h2>Purposes of the Messages</h2>
                        <p>
                            Text messages may be sent for purposes including, but not limited to:
                        </p>
                        <ul>
                            <li>Work at Home equipment return reminders</li>
                            <li>Return instructions and deadlines</li>
                            <li>Equipment pickup or shipping notifications</li>
                            <li>Return tracking and status updates</li>
                            <li>Confirmation of equipment receipt</li>
                            <li>Follow-up communications regarding outstanding company assets</li>
                            <li>Other communications reasonably necessary to facilitate the return, recovery, shipment, tracking, or receipt of company-issued Work at Home equipment.</li> </ul>

                        <h2>Service Providers and Mobile Information</h2>
                        <p>
                            Mobile information and text-messaging opt-in data and consent collected directly by Ibex in connection with an Ibex-sponsored workforce messaging program will not be sold or shared with third parties or affiliates for their independent marketing, advertising, or promotional purposes. Ibex may disclose such information to service providers as necessary to operate and support the applicable messaging program and subject to appropriate confidentiality and use restrictions.
                        </p>

                        <h2>Opt-Out Information</h2>
                        <p>
                            Recipients may opt out of receiving text messages by replying STOP to any message. Message and data rates may apply. Opting out of SMS communications does not relieve current or former employees of their obligation to return company-issued equipment, and Ibex may use other authorized communication methods to fulfill its operational and legal requirements.
                        </p>

                        <h2>Additional Privacy Information</h2>
                        <p>
                            This Privacy Notice supplements, and does not replace, the Ibex Privacy Policy for Human Resources Data. Additional information regarding Ibex’s collection, use, retention, disclosure, and protection of workforce personal information is provided in that policy, which is made available to members of the Ibex workforce.
                        </p>

                        <h2>Contact Information </h2>
                        <p>
                            If you have any questions regarding this Privacy Notice or the processing of your personal information, please contact the Ibex Data Privacy Office at:
                        </p>
                        <p>
                            Email:{' '}
                            <a href="mailto:dataprivacyoffice@ibex.co">
                                DataPrivacyOffice@ibex.co
                            </a>
                        </p>
                    </ScrollAnimation>
                </Container>
            </Wrapper>
        </Layout>
    );
};

const Wrapper = styled.div`
    background: #f5f5f5;
    padding: 60px 0;

    p {
        font-size: 16px;
        font-family: ${gilroyLight};
        line-height: 1.4;
        ${Media('xlscreens')} {
            font-size: 0.964vw;
        }
        a {
            color: ${colors.pink['100']};
        }
    }

    ul li,
    ol li {
        font-size: 16px;
        font-family: ${gilroyLight};
        padding-bottom: 10px !important;
        line-height: 1.4;
        ${Media('xlscreens')} {
            font-size: 0.964vw;
            padding-bottom: 0.595vw;
        }
        a {
            color: ${colors.pink['100']};
        }
    }

    ul,
    li {
        list-style: disc !important;
    }

    ul {
        padding-left: 1.5em;
        margin: 10px 0 20px;
    }

    h2 {
        font-size: 35px;
        font-family: ${gilroyBold};
        margin: 30px 0 0;
        line-height: inherit;
        ${Media('xlscreens')} {
            font-size: 1.84vw;
            margin: 1.585vw 0 0;
        }
        ${Media('tablet')} {
            font-size: 26px;
            margin: 20px 0 0;
        }
    }
`;

const MainHeading = styled.div`
    font-size: 50px;
    font-family: ${gilroyExtrabold};
    padding-bottom: 20px;
    ${Media('xlscreens')} {
        font-size: 3.012vw;
        padding-bottom: 1.05vh;
    }
    ${Media('tablet')} {
        font-size: 28px;
        line-height: 1.2;
        padding-bottom: 10px;
    }
`;

export default WorkforceMessagingPrivacy;
